import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { filter, take } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'lib-callback',
    standalone: true,
    template: `
    <div style="display: flex; align-items: center; justify-content: center; height: 100vh;">
      <div style="text-align: center;">
        <h2>Completing sign in...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
    </div>
  `
})
export class CallbackComponent implements OnInit {
    private platformId = inject(PLATFORM_ID);

    private oidcSecurityService = inject(OidcSecurityService);
    private router = inject(Router);


    ngOnInit() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        // The OIDC library automatically calls checkAuth() on initialization
        // We just need to wait for it to complete and then navigate
        this.oidcSecurityService.isAuthenticated$
            .pipe(
                filter(result => result.isAuthenticated === true),
                take(1)
            )
            .subscribe({
                next: () => {
                    const returnUrl = sessionStorage.getItem('returnUrl') || '/dashboard';
                    sessionStorage.removeItem('returnUrl');
                    this.router.navigateByUrl(returnUrl);
                },
                error: (err) => {
                    console.error('Authentication callback failed:', err);
                    this.router.navigate(['/dashboard']);
                }
            });
    }
}
